import axios from "../axios";
import { ResponseEnvelope } from "../types/types";
import { AiPromptResponse, PromptKey } from "../types/ai";

export async function listAiPrompts(): Promise<AiPromptResponse[]> {
  return (
    await axios.get<ResponseEnvelope<AiPromptResponse[]>>("/api/v1/ai-prompts")
  ).data.data;
}

export function fetchAiPrompt(key: PromptKey) {
  return axios.get<ResponseEnvelope<AiPromptResponse>>(
    `/api/v1/ai-prompts/${key}`
  );
}
